import { formatDocument } from "../../../utils/utils";

const Socios = ({ socios, isAdm = false }) => {
  const gridClass = isAdm ? "grid-cols-4" : "grid-cols-5";

  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div
            className={`grid gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500 ${gridClass}`}
          >
            <div className="col-span-2">Nome</div>
            <div className="text-center">Função</div>
            {!isAdm && <div className="text-center">Part. (%)</div>}
            <div className="text-center">Tem restrição?</div>
          </div>
        </div>

        {socios?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {socios?.map((socio, index) => (
              <div
                key={index}
                className={`grid gap-3 px-4 py-3 text-sm items-center ${gridClass} ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
              >
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {socio?.nome || "-"}
                  </div>
                  <div className="text-[11px] text-slate-500">
                    CPF: {socio?.cpf ? formatDocument(socio?.cpf) : "-"}
                  </div>
                </div>
                <div className="text-center text-slate-700">
                  {socio?.cargo || "-"}
                </div>
                {!isAdm && (
                  <div className="text-center text-slate-700">
                    {socio?.percentualParticipacao || "-"}
                  </div>
                )}
                <div className="text-center">
                  <span
                    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${
                      socio?.temRestricoes
                        ? "border-rose-200 bg-rose-50 text-rose-600"
                        : "border-emerald-200 bg-emerald-50 text-emerald-600"
                    }`}
                  >
                    {socio?.temRestricoes ? "Sim" : "Não"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Socios;
